import { httpService } from "@/common/services/HttpService";
import { AisleCategory } from "@/aisle-category/models/AisleCategory";

class AisleCategoryService {
  async getAisleCategories(): Promise<AisleCategory[]> {
    const { data } = await httpService.getInstance().get<AisleCategory[]>("/api/v1/backoffice/admin/aisles");
    return data;
  }

  async getAisleCategory(id: number): Promise<AisleCategory> {
    const { data } = await httpService.getInstance().get<AisleCategory>(`/api/v1/backoffice/admin/aisles/${id}`);
    return data;
  }

  async createAisleCategory(name: string, description?: string, image?: File): Promise<AisleCategory> {
    const formData = AisleCategoryService.createAisleCategoryFormData(name, description, image);
    const { data } = await httpService.getInstance().post<AisleCategory>(`/api/v1/backoffice/admin/aisles`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  }

  async updateAisleCategory(id: number, name: string, description?: string, image?: File): Promise<AisleCategory> {
    const formData = AisleCategoryService.createAisleCategoryFormData(name, description, image);
    const { data } = await httpService
      .getInstance()
      .patch<AisleCategory>(`/api/v1/backoffice/admin/aisles/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    return data;
  }

  private static createAisleCategoryFormData(name: string, description?: string, image?: File): FormData {
    const formData = new FormData();
    formData.append("name", name);
    if (description) formData.append("description", description);
    if (image) formData.append("image", image);
    return formData;
  }

  async deleteAisleCategory(id: number): Promise<void> {
    await httpService.getInstance().delete<AisleCategory>(`/api/v1/backoffice/admin/aisles/${id}`);
  }
}

export const aisleCategoryService = new AisleCategoryService();
